import React from 'react';

export const NotificationCancelIcon = () => {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="13" cy="13" r="12" stroke="#FF6534" strokeWidth="2" />
            <path
                d="M8.61523 17.6175L17.3845 8.38672"
                stroke="#FF6534"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.38446 8.61719L17.6152 17.3864"
                stroke="#FF6534"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
